import React, { useState, useEffect, useContext } from "react";
import AuthContext from "../../contexts/AuthContext";
import Button from "../../components/Form/Button";
import Group, { IGroup } from "../../services/api/Group";
import GroupList from "./components/GroupList";
import Form from "./components/Form";
import ContentHeader from "../../components/ContentHeader";
import { ReactComponent as UnitiesLogo } from "../../components/ContentHeader/assets/images/unities.svg";

const UnitiesGroups: React.FC = () => {
  const { user } = useContext(AuthContext);
  const readOnly = user!.profile.name === "Viewer";
  const [groups, setGroups] = useState<IGroup[]>([]);

  async function LoadGroups() {
    const response: IGroup[] = await Group.GetAll();
    setGroups(response);
  }

  useEffect(() => {
    LoadGroups();
  }, []);

  function toggleForm(e: any) {
    e.target.nextElementSibling.classList.toggle("form--open");
    e.target.parentNode.parentNode.parentNode.parentNode.classList.toggle(
      "form--open"
    );
  }

  return (
    <main className="wrapperApp">
      <ContentHeader
        title="Unities & Groups"
        Icon={UnitiesLogo}
        breadcrumb={["Unities & Groups"]}
      />

      <div id="content">
        <section className="content__block">
          <div className="content__header">
            <h2 className="content__title">CREATE OR EDIT GROUPS AND UNITS</h2>
            <div className="content__select">
              {readOnly ? null : (
                <Button
                  onClick={toggleForm}
                  title="Add New"
                  className="button button--blue button--icon button--add"
                />
              )}
              <div className="form--float">
                 <Form groups={groups} group={{} as IGroup} updateList={LoadGroups} />
              </div>
            </div>
          </div>

          <div className="groups  edit__buttons">
             <GroupList data={groups} updateList={LoadGroups} />
          </div>
        </section>
      </div>
    </main>
  );
};

export default UnitiesGroups;
